import React from "react";
import { Link } from "react-router-dom";
import { Gauge, MapPin, Fuel } from "lucide-react";
import { formatAZN, CountdownBadge, STATUS_LABELS, STATUS_STYLE } from "@/lib/format";

const FALLBACK = "https://images.unsplash.com/photo-1592309905620-e5b59f6dcb98?w=800&q=80";

export default function AuctionCard({ a }) {
  const mainImg = a.images?.[a.main_image_index ?? 0] || FALLBACK;
  return (
    <Link to={`/auction/${a.slug || a.id}`} data-testid={`auction-card-${a.id}`}
      className="group relative flex flex-col bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-xl hover:border-blue-200 transition-[box-shadow,border-color,transform] duration-300 hover:-translate-y-1">
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-slate-100">
        <img src={mainImg} alt={`${a.vehicle.brand} ${a.vehicle.model}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy" decoding="async" />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className={`px-2.5 py-1 rounded-md text-xs font-bold border ${STATUS_STYLE[a.status] || "bg-white text-slate-900 border-slate-200"}`}>
            {STATUS_LABELS[a.status] || a.status}
          </span>
        </div>
        <div className="absolute bottom-3 right-3 bg-slate-900/80 backdrop-blur px-2.5 py-1 rounded-md text-xs font-bold text-white">
          <CountdownBadge endIso={a.end_time} className="!text-white" />
        </div>
      </div>
      <div className="p-4 space-y-3">
        <div>
          <h3 className="font-bold text-lg text-slate-900 leading-tight truncate">{a.vehicle.brand} {a.vehicle.model}</h3>
          <p className="text-sm text-slate-500">{a.vehicle.year} • {a.vehicle.body_type}</p>
        </div>
        <div className="flex items-center gap-3 text-xs text-slate-600">
          <span className="flex items-center gap-1"><Gauge className="h-3.5 w-3.5" />{a.vehicle.mileage?.toLocaleString()} km</span>
          <span className="flex items-center gap-1"><Fuel className="h-3.5 w-3.5" />{a.vehicle.fuel_type}</span>
          <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{a.vehicle.city}</span>
        </div>
        <div className="flex items-end justify-between pt-2 border-t border-slate-100">
          <div>
            <p className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">Cari qiymət</p>
            <p className="font-mono text-xl font-bold text-slate-900">{formatAZN(a.current_price)}</p>
          </div>
          <div className="text-right">
            <p className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">Təkliflər</p>
            <p className="font-mono text-lg font-bold text-blue-600">{a.bid_count}</p>
          </div>
        </div>
      </div>
    </Link>
  );
}
